import { Swiper, SwiperProps } from '@gyym/ui'
import React from 'react'

import { SwiperContainer } from './styles'

export interface FacilityCardSwiperProps {
  id: string
  slides: React.ReactNode[]
  options?: Omit<SwiperProps, 'id' | 'slides'>
}

export const defaultSwiperOptions: Omit<SwiperProps, 'id' | 'slides'> = {
  virtual: { addSlidesAfter: 1 },
  pagination: true,
  navigation: true,
  spaceBetween: 8,
  breakpoints: {
    1000: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2.7,
      slidesPerGroup: 2,
      spaceBetween: 8,
    },
    600: {
      slidesPerView: 2.4,
      slidesPerGroup: 2,
      spaceBetween: 8,
    },
    480: {
      slidesPerView: 1.4,
      slidesPerGroup: 1,
      spaceBetween: 8,
    },
    0: {
      slidesPerView: 1.1,
      slidesPerGroup: 1,
      spaceBetween: 8,
    },
  },
}

export const FacilityCardSwiper = ({
  id,
  slides,
  options,
}: FacilityCardSwiperProps) => {
  return (
    <SwiperContainer>
      <Swiper
        {...defaultSwiperOptions}
        {...options}
        id={id}
        slides={slides}
        hideControlsOnMobile
      />
    </SwiperContainer>
  )
}
